export default {
  graphicriverNewFilters: 'hGxpr1OSS4ey3PIpje6V8w',
  videohiveNewFilters: 'ezJ-efn5Tu2Yfn6a5lmq5Q',
  audiojungleNewFilters: 'J5I2ROmGQEGRFlTpAkyEbw',
  codecanyonCollapsedFilters: '2WNyvxv8Rq2d_VO-p5x0Jg',
  themeforestCategoryFilter: 'xWkdeGDXQmCd6SDrdWLvzw',
  codecanyonFilterOrder: 'qOMGxJWHSaiPgMnmRDeP3w'
}
